<template>
    <div id="doubleCarousel">
        <div class="carOutBox" >
            <div v-for="(g, ix) in gameData" :key="ix">
                <div class="carContain animatsWords" v-if="ix == curInx">
                    <div class="carWords">
                        <h3 class="tit">
                            {{g.title}}
                        </h3>
                        <div class="carDivider"></div>
                        <div class="carDescri">
                            {{g.describe}}                    
                        </div>
                        <div class="medium-box" v-if="g.title==='Dragon Farm Adventure'">
                            <span>Follow us on</span>
                            <a href="https://www.youtube.com/channel/UCXpNd5kyZDKw5moj-Bm9yGg" target="_blank"><img src="../../../static/images/gameNewPic/youtube.png" /></a>
                            <a href="https://www.tiktok.com/@dragonfarmadventure1" target="_blank"><img src="../../../static/images/gameNewPic/tiktok.png" /></a>
                        </div>
                        <div class="carBtn">
                            <a v-bind:href="g.macurl" class="appstore">
                                <img :src="require('../../../static/images/gameNewPic/mac.svg')">
                            </a>
                            <a v-bind:href="g.googleurl" class="playstore">
                                <img :src="require('../../../static/images/gameNewPic/google.svg')">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="carBac animats" v-if="ix == curInx" :style="{background: 'url('+g.imgSrc+') no-repeat','background-size':'cover'}" @click="toNext"></div>
            </div>
            <div class="carouseBox">
                <!-- <el-carousel ref="carousel" trigger="click" @change="changeCarousel"  :autoplay="false" arrow="never">
                    <el-carousel-item v-for="(item, i) in gameData" :key="i">
                            <ul class="carCards " v-if="i == curInx">
                                <li class="cCard" v-for="(pic, inx) in item.listImg" :key="'img'+inx" :class="inx == 0 ? 'cCardOn' : 'cCardNot'">
                                    <img :src="pic.url" class="cCPic" :class="inx == 0 ? 'bigLight cCPicOn' : 'cCPicNot'" @click="setActiveItemCaro(pic.idx)">
                                </li>
                            </ul>
                    </el-carousel-item>
                </el-carousel> -->
                <otherCarousel @change="changeCarousel"></otherCarousel>
            </div>
            <div class="caPage">
                {{curPage}}/{{gameData.length}}
            </div>
        </div>
    
  </div>
</template>
<script>
import otherCarousel from './otherCarousel.vue'
// import picUrl1 from '../../../static/images/gameNewPic/1.jpg'
// import picUrl2 from '../../../static/images/gameNewPic/2.jpg'
import picUrl3 from '../../../static/images/gameNewPic/3.jpg'
import picUrl4 from '../../../static/images/gameNewPic/4.jpg'
import picUrl5 from '../../../static/images/gameNewPic/5.jpg'
import picUrl6 from '../../../static/images/gameNewPic/6.jpg'
import picUrl7 from '../../../static/images/gameNewPic/7.jpg'
// import picUrl8 from '../../../static/images/gameNewPic/8.jpg'
// import picUrl9 from '../../../static/images/gameNewPic/9.jpg'
// import picUrl10 from '../../../static/images/gameNewPic/10.jpg'
import picUrl12 from '../../../static/images/gameNewPic/12.jpg'
import picUrl13 from '../../../static/images/gameNewPic/13.jpg'
import picUrl14 from '../../../static/images/gameNewPic/14.jpg'
import picUrl15 from '../../../static/images/gameNewPic/15.jpg'
import picUrl16 from '../../../static/images/gameNewPic/16.jpg'
export default {
    name: 'doubleCarousel',
    components: {otherCarousel},
    data() {
        return {
            curPage: '01',
            curInx: 0,
            gameData: [
                    // {
                    //     title: 'Meeerge',
                    //     macurl:'https://apps.apple.com/us/app/meeerge/id1519746792',
                    //     googleurl:'https://play.google.com/store/apps/details?id=com.chaos.mergera',
                    //     describe: 'A divine artifact has been sealed from a dangerous spell. Heroes set forth on a journey with their tribe to discover mystical lands and recover the divine artifact. The only chance they fulfill the task is your merge magic to MATCH EVERYTHING!！',
                    //     imgSrc: require('../../../static/images/gameNewPic/1bac.jpg'),
                    //     listImg: [
                    //         {
                    //             idx: 0,
                    //             url: picUrl1,
                    //         },
                    //         {
                    //             idx: 1,
                    //             url: picUrl2,
                    //         },
                    //         {
                    //             idx: 2,
                    //             url: picUrl3,
                    //         },
                    //         {
                    //             idx: 3,
                    //             url:  picUrl4,
                    //         },
                    //         {
                    //             idx: 4,
                    //             url: picUrl5
                    //         },
                    //     ]
                    // },
                    // {
                    //     title: 'Buddies',
                    //     macurl:"https://apps.apple.com/us/app/word-buddies-fun-puzzle-game/id1461700291",
                    //     googleurl:"https://play.google.com/store/search?q=Word%20Buddies&c=apps",
                    //     describe: 'Word Buddies is a free and fun crossword game. It will exercise your brain and expand your vocabulary. It’s definitely the most interesting word game for you to kill time and relax.',
                    //     imgSrc: require('../../../static/images/gameNewPic/2bac.jpg'),
                    //     listImg: [
                    //         {
                    //             idx: 1,
                    //             url: picUrl2,
                    //         },
                    //         {
                    //             idx: 2,
                    //             url: picUrl3,
                    //         },
                    //         {
                    //             idx: 3,
                    //             url: picUrl4,
                    //         },
                    //         {
                    //             idx: 4,
                    //             url: picUrl5,
                    //         },
                    //         {
                    //             idx: 5,
                    //             url: picUrl6,
                    //         },
                            
                    //     ]
                    // },
                    {
                        title: 'Crossy',
                        macurl:"https://apps.apple.com/us/app/word-crossy-a-crossword-game/id1273162445",
                        googleurl:"https://play.google.com/store/search?q=Word%20Crossy&c=apps",
                        describe: 'Word Crossy is a relaxing Word game where you connect letters together to form words on a crossword-style board. Learn while you play! With over 12，000 levels and thousands of words ranging from simple to complex, Word Crossy will help you become a true Word Master.',
                        imgSrc: require('../../../static/images/gameNewPic/3bac.jpg'),
                        listImg: [
                            {
                                idx: 0,
                                url: picUrl3,
                            },
                            {
                                idx: 1,
                                url: picUrl12,
                            },
                            {
                                idx: 2,
                                url: picUrl4,
                            },
                            {
                                idx: 3,
                                url: picUrl5,
                            },
                            {
                                idx: 4,
                                url: picUrl6,
                            },
                        ]
                    },
                    {
                        title: 'Jackpotland',
                        describe: 'Welcome to Jackpotland, where thrill meets fortune! Immerse yourself in a world of excitement and chance as we unveil an extraordinary gaming experience designed to elevate your entertainment to new heights. Get ready to embark on a journey filled with thrilling games, dazzling jackpots, and endless possibilities.',
                        imgSrc: require('../../../static/images/gameNewPic/12bac.jpg'),
                        listImg: [
                            {
                                idx: 1,
                                url: picUrl12,
                            },
                            {
                                idx: 2,
                                url: picUrl4,
                            },
                            {
                                idx: 3,
                                url: picUrl5,
                            },
                            {
                                idx: 4,
                                url: picUrl6,
                            },
                            {
                                idx: 5,
                                url: picUrl7,
                            },
                        ]
                    },
                    {
                        title: 'Crush',
                        macurl:"https://apps.apple.com/in/app/word-crush-fun-puzzle-game/id1446728841",
                        googleurl:"https://play.google.com/store/apps/details?id=com.tangramgames.gourddoll.wordcrush",
                        describe: 'Are you looking for a new word game? Do you want to immerse yourself into a challenging intellectual competition? Come and play the word game and embark on a new trip! You only need to connect and match the letters in the word puzzles.',
                        imgSrc: require('../../../static/images/gameNewPic/4bac.jpg'),
                        listImg: [
                            {
                                idx: 2,
                                url: picUrl4,
                            },
                            {
                                idx: 3,
                                url: picUrl5,
                            },
                            {
                                idx: 4,
                                url: picUrl6,
                            },
                            {
                                idx: 5,
                                url: picUrl7,
                            },
                            {
                                idx: 6,
                                url: picUrl13,
                            },
                            
                        ]
                    },
                    {
                        title: 'Dragon Farm Adventure',
                        macurl:"https://apps.apple.com/au/app/dragon-farm-adventure/id1563159261",
                        googleurl:"https://play.google.com/store/search?q=Dragon%20Farm%20Adventure&c=apps",
                        describe: 'Welcome to the ultimate experience of farming and adventure! Go on a fantastic adventure with lovely dragons! Build a farm, explore mysterious islands, discover the secrets of dragons, and complete various challenging missions! Come and join this mysterious and exciting adventure!',
                        imgSrc: require('../../../static/images/gameNewPic/5bac.jpg'),
                        listImg: [
                            {
                                idx: 3,
                                url: picUrl5,
                            },
                            {
                                idx: 4,
                                url: picUrl6,
                            },
                            {
                                idx: 5,
                                url: picUrl7,
                            },
                            {
                                idx: 6,
                                url: picUrl13,
                            },
                            {
                                idx: 7,
                                url: picUrl14,
                            },
                        ]
                    },
                    {
                        title: 'Solitaire Home Design',
                        macurl:"https://apps.apple.com/us/app/solitaire-home-design-fun-game/id1492964317",
                        googleurl:"https://play.google.com/store/search?q=Solitaire%20Home%20Design&c=apps",
                        describe: 'Lori and Eddie embark on a journey of transforming and renovating an entire island into a beautiful paradise. At the same time, you’ll enjoy solitaire games to exercise your brain and become smarter',
                        imgSrc: require('../../../static/images/gameNewPic/6bac.jpg'),
                        listImg: [
                            {
                                idx: 4,
                                url: picUrl6,
                            },
                            {
                                idx: 5,
                                url: picUrl7,
                            },
                            {
                                idx: 6,
                                url: picUrl13,
                            },
                            {
                                idx: 7,
                                url: picUrl14,
                            },
                            {
                                idx: 8,
                                url: picUrl15,
                            },
                            
                        ]
                    },
                    {
                        title: 'Mergical',
                        macurl:"https://apps.apple.com/us/app/mergical-match-island-game/id1459499304",
                        googleurl:"https://play.google.com/store/search?q=Mergical&c=apps",
                        describe: 'Welcome to the fantastic Mergical Island! This is a mysterious land full of magical fantasies. Here, you can explore the lost world, also to build and design the island based on your preference! A perfect merge and building game!',
                        imgSrc: require('../../../static/images/gameNewPic/7bac.jpg'),
                        listImg: [
                            {
                                idx: 5,
                                url: picUrl7,
                            },
                            {
                                idx: 6,
                                url: picUrl13,
                            },
                            {
                                idx: 7,
                                url: picUrl14,
                            },
                            {
                                idx: 8,
                                url: picUrl15,
                            },
                            {
                                idx: 9,
                                url: picUrl16,
                            }, 
                            
                        ]
                    },
                    // {
                    //     title: 'Tank Hero',
                    //     macurl:"https://apps.apple.com/us/app/tank-hero-the-fight-begins/id1481316255",
                    //     googleurl:"https://play.google.com/store/apps/details?id=com.tankgame.tankhero.en",
                    //     describe: 'The tank war has begun, the enemies are gathered for an attack. All you can do now, is to use your special ability to defend against waves of enemy tanks, then find the opportunity for a counter attack. Remember, once you die, you will restart from the beginning.',
                    //     imgSrc: require('../../../static/images/gameNewPic/8bac.jpg'),
                    //     listImg: [
                    //         {
                    //             idx: 7,
                    //             url: picUrl8,
                    //         }, 
                    //         {
                    //             idx: 8,
                    //             url: picUrl9,
                    //         }, 
                    //         {
                    //             idx: 9,
                    //             url: picUrl10,
                    //         }, 
                    //         {
                    //             idx: 0,
                    //             url: picUrl1,
                    //         }, 
                    //         {
                    //             idx: 1,
                    //             url: picUrl2,
                    //         }, 
                            
                    //     ]
                    // },
                    // {
                    //     title: 'Townest',
                    //     macurl:"https://apps.apple.com/us/app/townest-alfreds-adventure/id1435277159",
                    //     googleurl:"https://play.google.com/store/search?q=Townest&c=apps",
                    //     describe: "Welcome to Townest: Alfred’s Adventure! Check out this magical town full of mysteries. Help Alfred restore his hometown, renovate, and pass levels to find clues on his missing grandmother.",
                    //     imgSrc: require('../../../static/images/gameNewPic/9bac.jpg'),
                    //     listImg: [
                    //         {
                    //             idx: 8,
                    //             url: picUrl9,
                    //         }, 
                    //         {
                    //             idx: 9,
                    //             url: picUrl10,
                    //         }, 
                    //         {
                    //             idx: 0,
                    //             url: picUrl1,
                    //         }, 
                    //         {
                    //             idx: 1,
                    //             url: picUrl2,
                    //         }, 
                    //         {
                    //             idx: 2,
                    //             url: picUrl3,
                    //         }, 
                            
                    //     ]
                    // },
                    // {
                    //     title: 'Word Villas',
                    //     macurl:"https://apps.apple.com/us/app/word-villas-crossword-design/id1466588301",
                    //     googleurl:"https://play.google.com/store/search?q=Word%20Villas&c=apps",
                    //     describe: 'Design your dream home with Word Villas! This game is the perfect combination of Word Puzzles and Home Decorating. Start your adventure by helping Rachel renovate her old house and start a new life!',
                    //     imgSrc: require('../../../static/images/gameNewPic/10bac.jpg'),
                    //     listImg: [
                    //         {
                    //             idx: 9,
                    //             url: picUrl10,
                    //         }, 
                    //         {
                    //             idx: 0,
                    //             url: picUrl1,
                    //         }, 
                    //         {
                    //             idx: 1,
                    //             url: picUrl2,
                    //         }, 
                    //         {
                    //             idx: 2,
                    //             url: picUrl3,
                    //         }, 
                    //         {
                    //             idx: 3,
                    //             url: picUrl4,
                    //         }, 
                    //     ]
                    // },
                    {
                        title: 'Legendary Monster',
                        describe: 'Embark on a journey through the world of Legendary Monster, where you can nurture and train all your monsters, forging a formidable legion to face a myriad of challenges! Collect rare monsters and resources in various challenges, and battle against other top Titan behemoths until you reign supreme as the ruler of Earth!',
                        imgSrc: require('../../../static/images/gameNewPic/13bac.jpg'),
                        listImg: [
                            {
                                idx: 6,
                                url: picUrl13,
                            }, 
                            {
                                idx: 7,
                                url: picUrl14,
                            }, 
                            {
                                idx: 8,
                                url: picUrl15,
                            }, 
                            {
                                idx: 9,
                                url: picUrl16,
                            }, 
                            {
                                idx: 0,
                                url: picUrl3,
                            },
                        ]
                    },
                    {
                        title: 'Block Guru',
                        describe: 'Welcome to Block Guru - Wood 3D Cube, where you can embark on the journey to become a master of Block! This game cleverly combines classic Tetris with various puzzles and decryption challenges, offering a comprehensive brain workout and boosting your cognitive abilities. Join in the fun of exploring the world of blocks with friends and family, and compete to see who can complete the levels the fastest! The next block guru could be you!',
                        imgSrc: require('../../../static/images/gameNewPic/14bac.jpg'),
                        listImg: [
                            {
                                idx: 7,
                                url: picUrl14,
                            }, 
                            {
                                idx: 8,
                                url: picUrl15,
                            }, 
                            {
                                idx: 9,
                                url: picUrl16,
                            }, 
                            {
                                idx: 0,
                                url: picUrl3,
                            }, 
                            {
                                idx: 1,
                                url: picUrl12,
                            }, 
                        ]
                    },
                    {
                        title: 'Tile Tap',
                        describe: 'Embark on a journey of luck and tranquility with Tile Tap.Tile Tap not only brings you relaxation for the mind and tranquility for the soul but also cultivates a serene and Zen-like atmosphere. Immerse yourself in the world of Tile Tap, where matching three tiles not only provides an extraordinary experience of traditional matching games but also offers meticulously crafted and daily updated puzzles. Tile Tap is a revolutionary version of classic matching games. Seamlessly integrating into your daily life or joyful travels, Tile Tap provides a series of puzzles and challenges waiting to be explored.',
                        imgSrc: require('../../../static/images/gameNewPic/15bac.jpg'),
                        listImg: [
                            {
                                idx: 8,
                                url: picUrl15,
                            }, 
                            {
                                idx: 9,
                                url: picUrl16,
                            }, 
                            {
                                idx: 0,
                                url: picUrl3,
                            }, 
                            {
                                idx: 1,
                                url: picUrl12,
                            }, 
                            {
                                idx: 2,
                                url: picUrl4,
                            }, 
                        ]
                    },
                    {
                        title: 'Gold Valley',
                        describe: "Welcome all lumber tycoons to Gold Valley! Here, chopping trees isn't just a way to earn coins and gems, it's also an opportunity to build a lumber empire. Merge lumberjacks, overcome obstacles, collect cards to upgrade characters and skills, and explore the mysteries of each area. Join thrilling lumber competitions, defeat powerful bosses, and win handsome rewards! Let this beautiful town gradually flourish and become the most dazzling lumber tycoon in Gold Valley!",
                        imgSrc: require('../../../static/images/gameNewPic/16bac.jpg'),
                        listImg: [
                            {
                                idx: 9,
                                url: picUrl16,
                            }, 
                            {
                                idx: 0,
                                url: picUrl3,
                            }, 
                            {
                                idx: 1,
                                url: picUrl12,
                            }, 
                            {
                                idx: 2,
                                url: picUrl4,
                            }, 
                            {
                                idx: 3,
                                url: picUrl12,
                            }, 
                        ]
                    },
            ]
        }
    },
    computed: {

    },
    methods: {
        changeCarousel(newP, oldP) {
            if (newP < this.gameData.length - 1) {
                this.curPage = '0'+(newP+1);
            } else {
                this.curPage = ''+(newP+1);
            }
            this.curInx = newP;
        },
        toNext() {
            this.$refs.carousel.next()
        },
        setActiveItemCaro(i) {
            this.$refs.carousel.setActiveItem(i)
        }
    }
}
</script>
<style lang="less" scoped>
.medium-box{
    position: absolute;
    left: 0;
    top: 260px;
    >span{
        font-size: 16px;
    }
    img{
        width: 80px;
        margin-left: 15px;
        vertical-align: middle;
    }
}
#doubleCarousel{
    position:relative;
    height:100vh;
    overflow:hidden;
    min-width: 1380px;
    margin: 0 auto;
}

  .el-carousel__item h3 {
    color: #fff;
    font-size: 18px;
    opacity: 1;
    line-height: 300px;
    margin: 0;
  }
  .carOutBox{
      position:relative;
    //   height: 1080px;
      width:100%;
  }
  .carWords{
    //   position:absolute; 
    //   left: 60px;
    //   top: 379px;
    //   bottom: 138px;
      text-align: left;
      color: #FFFFFF;
      .tit{
        // font-family: 'Source Han Sans CN';
        height: 41px;
        font-size: 36px;
        font-weight: 400;
      }
      .carDivider{
        width: 57px;
        height: 3px;
        background: #FFFFFF; 
        margin: 43px 0 40px;
      }
      .carDescri{
        width: 398px;
        font-size: 14px;
        // font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #FFFFFF;
        opacity: 1;
        line-height:22px;
      }
      .carBtn{
          margin-top: 90px;
          img{
              margin-right: 30px;
          }
      }
      .appstore:hover{
          filter: invert(1);
          animation-duration: 50ms; //没有加入浏览器支持语句
      }
      .playstore:hover{
          filter: invert(1);
          animation-duration: 50ms; //没有加入浏览器支持语句
      }
  }
  .carCards{
      .cCard{
          width:168px;
          height:248px;
          float:left;
          margin-right:15px;
          border-radius: 14px;
      }

      .cCardNot{
          background:#000;
      }
  }
  .carouseBox{
      height: 292px;
      width:1000px;
      position: absolute;
      right: -144px;
    //   top:387px;
      bottom: 180px;
      animation: 1.35s;
      .cCPic{
            width:168px;
            height:248px;            
            position: relative;
            border-radius: 14px;
        }
      .cCPicOn {
          opacity: 1;
          top:-0px;
          left: -15px;
          transform: scale(1.17);  /*开始为原始大小*/
          box-shadow: 0px 0px 15px #fffa688a;
          z-index: 10000;
      } 
      .cCPicNot{
          opacity: 0.6;
      }

  }

  .carBac{
        position:absolute;
        background: url('../../../static/images/gameNewPic/1bac.jpg') no-repeat;
        background-size: cover;
        opacity: 0.4;
        height: 100vh;
        width:100vw;
        top: 0;
        bottom:0;   
        
        mask: linear-gradient(transparent , #fff 0);
        mask-size: 100% 100%;
        mask-position:50% 50%;
        mask-repeat: no-repeat;
    }
    .carContain{
        // position:relative;
        position: absolute;
        left: 60px;
        bottom: 138px;
        z-index: 200;
        
    }
  .caPage{
    position:absolute;
    // top: 742px;
    bottom: 100px;
    right:60px;
    height: 21px;
    font-size: 24px;
    // font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 0px;
    color: #FFFFFF;
    z-index: 2000;
}
      .animats{
            position:relative;
            // animation:mymove 1.35s infinite;
            animation:mymove 0.8s;
            -webkit-animation:mymove 0.8s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:mymove 0.8s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
            // animation-delay: 0.4s;
            // -webkit-animation-delay: 0.4s;
            // animation-fill-mode : backwards;
            // -webkit-animation-fill-mode : backwards
        }

        @keyframes mymove
            {
                0%{
                    mask:
                    linear-gradient(transparent , #fff 0);
                    mask-size: 40% 40%;
                    mask-position:50% 50%;
                    mask-repeat: no-repeat;
                }
                100%{
                    mask:
                        linear-gradient(transparent , #fff 0);
                        mask-size: 100% 100%;
                        mask-position:50% 50%;
                        mask-repeat: no-repeat;
                }

            }
        .animatsWords{
            // position:relative;
            // animation:mymove 1.35s infinite;
            animation:wordmove 1s;
            animation-delay: 10s;
            -webkit-animation-delay: 10s;
            -webkit-animation:wordmove 1s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:wordmove 1s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
        }

        @keyframes wordmove
            {
                0%{
                    transform: translate(0px, 250px);
                    opacity: 0;
                }
                50%{
                    transform: translate(0px, 250px);
                    opacity: 0;
                }
                75%{
                    transform: translate(0px, 90px);
                }
                100%{
                    opacity: 1;
                    transform: translate(0px, 0px)
                }

            }
        .bigLight{
            position:relative;
            // animation:mymove 1.35s infinite;
            animation:cardsmove 1.35s;
            -webkit-animation:cardsmove 1.35s; /*Safari and Chrome*/
            // animation-direction:alternate;/*轮流反向播放动画。*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:cardsmove 1.35s;
            // -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
        }
        @keyframes cardsmove
            {
                0%{
                transform: scale(1.17);
                box-shadow: 0px 0px 15px #FFFA68;
                opacity: 0.3;
                }
                25%{
                    transform: scale(1); 
                }
                50%{
                    transform: scale(1.17);
                }
                100%{
                    transform: scale(1.17);
                    opacity: 1;
                    box-shadow: 0px 0px 15px #FFFA68;

                }

            }
</style>




// WEBPACK FOOTER //
// src/components/parts/doubleCarousel.vue